export const isMobile = () => {
    return window.innerWidth <= 768; // Adjust the breakpoint as needed
}